<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" ref="layout" v-wechat-title="$t($route.meta.title)"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" ref="layout" v-wechat-title="$t($route.meta.title)"/>
  </div>
</template>

<script>
import MainLayout from "./views/Layout.vue";
export default {
  name: "app",
  methods: {}
};
</script>
<style>
#app {
  font-family: "Microsoft Yahei", "微软雅黑", Tahoma, Arial, Helvetica, STHeiti;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #36383c;
  height: 100%;
}
</style>
<style scoped>
</style>

